export default {
  getAccountList: state => state.gridData,
  getAccountInfo: state => state.accountInfo,
  getRootAccountList: state => state.rootGridData,
  getRootAccountInfo: state => state.rootAccountInfo,
};



// WEBPACK FOOTER //
// ./src/vuex/accountManagement/accountRequest/accountRequestGetter.js